/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import Content from './Content/index'
import FilterAction from './FilterAction/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content"
  
}) {
  return (<React.Fragment
>
<FilterAction
  viewPath={`${viewPath}/FilterAction`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
{children}
</React.Fragment>)
}